export const getLocalStorageItem = (key: string) => {
  return localStorage.getItem(key);
};

export const setLocalStorageItem = (key: string, value: any) => {
  return localStorage.setItem(key, value);
};
export const removeLocalStorageItem = (key: string) => {
  return localStorage.removeItem(key);
};
export const setLocalStorageAccessToken = (token: string) =>
  setLocalStorageItem("_token", token);

export const setLocalStorageRefreshToken = (token: string) =>
  setLocalStorageItem("refreshToken", token);

export const removeLocalStorageAccessToken = () =>
  localStorage.removeItem("_token");

export const removeLocalStorageRefreshToken = () =>
  localStorage.removeItem("refreshToken");

export const getLocalStorageAccessToken = () =>
  getLocalStorageItem("_token");

export const getLocalStorageRefreshToken = () =>
  getLocalStorageItem("refreshToken");
